import loadTikTok from './tiktok';
import loadIntercom from './intercom';
import loadFacebookPixel from './facebook';
import { sendGTMEvent } from './gtm';

import { 
  isProduction,
  getVisitor,
  checkIfDeviceAllowsEditing,
  getRandomString
} from '../helpers';

var areDeferredListenersAdded = false;

window.trackEvent = _trackEvent;

window.addEventListener('load', onLoad);

document.addEventListener('DOMContentLoaded', onDOMContentLoaded);

function onDOMContentLoaded() {
  sendGTMEvent('napkin_set_visitor', {
    visitor: getVisitor(),
  });
}

function onLoad() {
  console.debug('[Analytics] Loaded');

  // Global variables
  window.canEditOnDevice = checkIfDeviceAllowsEditing();
  window.visitor = getVisitor();
  window.currentSessionId = getRandomString();
  
  window.trackEvent('js_loaded');

  // Only load analytics trackers in production
  if (!isProduction()) {
    return;
  }

  loadTikTok(() => {
    console.debug('TikTok loaded');
  });
  loadFacebookPixel(() => {
    console.debug('Facebook Pixel loaded');
  });

  window.setTimeout(() => {
    _loadDeferredListeners();
  }, 1000);

  // Scroll listeners
  window.addEventListener('scroll', _loadDeferredListeners);
}

function _trackEvent(eventName, eventProperties = {}, withTimestamps = true) {
  try {

    if (withTimestamps) {
      if (!window.timestamps) {
        window.timestamps = [];
      }

      window.timestamps.push({
        event: eventName,
        timestamp: Date.now(),
        ...eventProperties,
      });
    }

    sendGTMEvent(eventName, eventProperties, withTimestamps);

    console.debug('Tracked event:', eventName, eventProperties, withTimestamps);
  } catch (e) {
    console.error('Error while tracking event ' + eventName, e);
  }
}

function _loadDeferredListeners() {
  if (!areDeferredListenersAdded) {
    areDeferredListenersAdded = true;
    window.removeEventListener('scroll', _loadDeferredListeners);

    _loadIntercom();
  }
}

function _loadIntercom() {
  if (window.requestIdleCallback) {
    window.requestIdleCallback(() => {
      loadIntercom(() => {
        console.debug('Intercom loaded (idle callback)');
      });
    });
  } else {
    loadIntercom(() => {
      console.debug('Intercom loaded');
    });
  }
}

